import { render } from "./Docusaurus.vue?vue&type=template&id=798130b4"
import script from "./Docusaurus.vue?vue&type=script&lang=js"
export * from "./Docusaurus.vue?vue&type=script&lang=js"

import "./Docusaurus.vue?vue&type=style&index=0&id=798130b4&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__